import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Rightcontainer from '../Components/Rightcontainer'
import Header from '../Components/Header'
import '../css/terms.css'
import axios from 'axios'
import { Interweave } from 'interweave'
import { apiRequest } from '../store/allApi'
const RefundPolicy = () => {
  const [data, setData] = useState()

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 


  const getdata = async () => {

    try {
      const res = await apiRequest('api/term/condition/Refund_Policy', "GET", null)
      setData(res.data[0].Desc)
    } catch (e) {

    }
  }
  useEffect(() => {
    getdata()
  }, [])

  return (
    <div>
      <div
        className='leftContainer mb_space'
      >
        <div className='mt-5 py-4 px-3'>
          <div className='m-3'>
            <h1 className='profile_headings' style={{ color: "black" }}>Refund Policy</h1>


            <>
              <p className='p2 small_para'>
                Thank you for choosing SKILLSONOMY("we," "us," or "our"), a product of SKILLSONOMY INFO PRIVATE LIMITED. This policy outlines the terms for refunds related to in-app purchases, subscriptions, and deposits. By using our platform, you agree to this polic
              </p>
              <p className='other_page_small_headings'> Refund Eligibility</p>
              <p className='p2 small_para'>
                Approved Refund Requests:
              </p>
              <p className='p2 small_para'>
                Refunds may be issued only under the following circumstances: <br />

                Technical Failures: Unresolved glitches (e.g., payment deducted but chips not credited). <br />

                Duplicate Charges: Accidental multiple transactions for the same purchase. <br />

                Unauthorized Transactions: Fraudulent activity (subject to investigation).
              </p>

              <p className='p2 small_para'>
                Non-Refundable Cases:
              </p>

              <p className='p2 small_para'>
                Losses in skill-based games (e.g., Ludo, Chess). <br />

                Voluntary deposits or in-app purchases after 24 hours. <br />

                Account bans due to violations of our Terms of Service.
              </p>

              <p className='other_page_small_headings'> How to Request a Refund</p>

              <p className='p2 small_para'>
                Contact Support:
              </p>
              <p className='p2 small_para'>
                Email: support@SKILLSONOMY.com <br />

                In-App: Use the "Help & Support" section.
              </p>
              <p className='p2 small_para'>
                Provide Details:
              </p>
              <p className='p2 small_para'>
                Transaction ID. <br />
                Screenshot/video proof of the issue. <br />
                Reason for the refund request.
              </p>


              <p className='other_page_small_headings'>  Refund Processing</p>
              <p className='p2 small_para'>
                Timeline:
              </p>
              <p className='p2 small_para'>
                Approved refunds will be processed within 7 working days.<br />

                The credited amount may take 3–10 business days to reflect, depending on your payment provider.
              </p>
              <p className='p2 small_para'>
                Method:
              </p>
              <p className='p2 small_para'>
                Refunds are issued to the original payment method only.
              </p>


              <p className='other_page_small_headings'>  Subscription Cancellations</p>
              <p className='p2 small_para'>
                Active Subscriptions:
              </p>
              <p className='p2 small_para'>
                No refunds for partial/unused subscription periods.<br />

                Cancel anytime to avoid future charges.
              </p>

              <p className='p2 small_para'>
                Trial Periods:
              </p>
              <p className='p2 small_para'>
                Free trials auto-convert to paid subscriptions unless canceled before renewal.

              </p>
            </>
          </div>
        </div>
      </div>
      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </div>
  )
}
export default RefundPolicy
